import React from 'react';

const PHPLogo = (props) => (
    <svg viewBox="0 -1 100 50" {...props}>
        <path d="M7.6 10.1h14.2c4.2 0 7.2 1.3 9 3.6 2 2.4 2.5 5.6 1.9 9.7a18.6 18.6 0 01-5 10.4c-1.8 1.9-3.7 3-5.7 3.5s-4.1.8-6.3.8H9.4l-2 10H0l7.6-38m6.2 6l-3.2 16H12c3.4 0 6.2-.3 8.5-1 2.2-.7 3.7-3.3 4.5-7.7.7-3.7 0-5.9-1.9-6.4a23.8 23.8 0 00-8.3-.8h-1M41 0h7.4l-2 10.1h6.5c3.6 0 6.3.8 8 2.2 1.9 1.5 2.4 4.1 1.7 8.1L59 38.1h-7.4L55 21.2c.3-1.8.2-3-.3-3.8-.6-.7-1.8-1-3.7-1l-5.9-.1L40.8 38h-7.3L41 0m29.4 10.1h14.2c4.2 0 7.2 1.3 9 3.6 2 2.4 2.6 5.6 2 9.7a18.6 18.6 0 01-5.1 10.4c-1.8 1.9-3.7 3-5.7 3.5s-4 .8-6.2.8h-6.4l-2 10h-7.4l7.6-38m6.2 6l-3.2 16h1.4c3.4 0 6.2-.3 8.5-1s3.8-3.3 4.5-7.7c.7-3.7 0-5.9-1.9-6.4a23.8 23.8 0 00-8.2-.8h-1.1" />
    </svg>
);

export default PHPLogo;
